// extracted by mini-css-extract-plugin
export default {"container":"n0-z","list":"o0-z"};